import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import {renderModal} from "./modal.jsx";
import {
  LDP_METRICS_OTHER_PAGE,
  LDP_METRICS_PROFILE_PAGE,
  LDP_METRICS_RETAILER_CLASSNAME,
  LDP_METRICS_STORE_CLASSNAME,
  LDP_METRICS_STORE_LOCATOR_PAGE,
  LDP_METRICS_TRY_THIS_BED_PAGE
} from "../../constants.js";

import DataLayerService from "datalayer-service/src/datalayer.ts";
import {CTAClickCategory, CTAClickLevel} from "datalayer-service/src/types/enums";

export const ID = "send-text-btn";
const dataLayerService = new DataLayerService(window);

const SendTextButton = ({
    retailerID,
    storeID,
    storeSlug,
    storeName,
    retailerSlug,
    retailerName,
    locationPage,
    pageRegion,
    isLDP,
    objectClassname,
    isQuickView,
}) => {
    const handleSendTextClick = () => {
        renderModal({
            retailerID,
            storeID,
            storeSlug,
            retailerSlug,
            retailerName,
            storeName,
            locationPage,
            pageRegion,
            isLDP,
            objectClassname,
            isQuickView,
        });


        dataLayerService.CTAClickEvent({
          category: CTAClickCategory.TEXT_STORE,
          level: CTAClickLevel.SECONDARY,
          pageRegion: pageRegion,
          store: {
            isLDP: isLDP === undefined ? "" : isLDP === "true",
            retailerLocation: storeSlug || retailerSlug || "",
            retailerName: storeName || retailerName,
          }
        });
    };

    return (
        <button
            className="btn send-text-btn"
            data-dismiss="modal"
            onClick={handleSendTextClick}
        >
            <i className="fa fa-comment-o"></i>
            Text Store
        </button>
    );
};

SendTextButton.propTypes = {
    retailerID: PropTypes.string.isRequired,
    storeID: PropTypes.string,
    retailerSlug: PropTypes.string,
    retailerName: PropTypes.string,
    storeSlug: PropTypes.string.isRequired,
    storeName: PropTypes.string.isRequired,
    locationPage: PropTypes.oneOf([
        LDP_METRICS_STORE_LOCATOR_PAGE,
        LDP_METRICS_TRY_THIS_BED_PAGE,
        LDP_METRICS_OTHER_PAGE,
        LDP_METRICS_PROFILE_PAGE,
    ]).isRequired,
    isLDP: PropTypes.string,
    objectClassname: PropTypes.oneOf([
        LDP_METRICS_STORE_CLASSNAME,
        LDP_METRICS_RETAILER_CLASSNAME,
    ]),
    isQuickView: PropTypes.bool,
    pageRegion: PropTypes.string,
};

SendTextButton.defaultProps = {
    objectClassname: LDP_METRICS_STORE_CLASSNAME,
    isQuickView: false,
};

export default SendTextButton;

export function renderSendButton(selector = `[id=${ID}]`) {
    const elements = document.querySelectorAll(selector);

    for (let element of elements) {
        const retailerID = element.getAttribute("data-retailer-id");
        const storeID = element.getAttribute("data-store-id");
        const storeSlug = element.getAttribute("data-store-slug");
        const retailerSlug = element.getAttribute("data-retailer-slug");
        const retailerName = element.getAttribute("data-retailer-name");
        const storeName = element.getAttribute("data-store-name");
        const locationPage = element.getAttribute("data-location-page");
        const pageRegion = element.getAttribute("data-page-region");
        const isLDP = element.getAttribute("data-is-ldp");
        const objectClassname = element.getAttribute("data-object-classname");
        const isQuickView = element.getAttribute("data-quick-view");

        ReactDOM.render(
            <SendTextButton
                retailerID={retailerID}
                retailerSlug={retailerSlug}
                retailerName={retailerName}
                storeID={storeID}
                storeSlug={storeSlug}
                storeName={storeName}
                locationPage={locationPage}
                pageRegion={pageRegion}
                isLDP={isLDP}
                objectClassname={objectClassname}
                isQuickView={isQuickView ? isQuickView === "true" : false}
            />,
            element
        );
    }
}

function renderFirstModal(selector = `[id=${ID}]`) {
    const urlParams = new URLSearchParams(window.location.search);
    const openModal = urlParams.get('sms')

    if (!openModal) return;

    const elements = document.querySelectorAll(selector);

    if (elements.length > 0) {
        // Passing ?send-text=1 in the URL will force-open the first modal
        // right after loading the page.

        let element = elements.item(0);
        setTimeout(function () {
            renderModal({
                retailerID: element.getAttribute("data-retailer-id"),
                storeID: element.getAttribute("data-store-id"),
                storeSlug: element.getAttribute("data-store-slug"),
                storeName: element.getAttribute("data-store-name"),
                retailerSlug: element.getAttribute("data-retailer-slug"),
                retailerName: element.getAttribute("data-retailer-name"),
                pageRegion: element.getAttribute("data-page-region"),
                locationPage: element.getAttribute("data-location-page"),
                objectClassname: element.getAttribute("data-object-classname"),
                isQuickView: element.getAttribute("data-quick-view") === "true"
            });
        }, 200);

    }
}

window.addEventListener('load', (event) => {
    renderSendButton();
    renderFirstModal();
});
